export default "__VITE_ASSET__DiDA1TBh__"